import { css } from '@emotion/core';

export const iconCss = invert =>
  css({
    marginLeft: !invert && 9,
    marginRight: invert && 9,
    fontSize: 17,
  });

export const linkCss = invert =>
  css({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: invert ? 'row-reverse' : 'row',
    alignItems: 'center',
  });
